type PostData = {
  companyName: string | null
  firstName: string | null
  lastName: string | null
  email: string | null
  phoneNo: string
  selectedCountry: number
  countryPhoneCode: number // Add this property
  activity: number
  department: string | null
  message: string | null
  sendCopy: boolean
}

export const postBuyerAlertContactUs = async (postData: PostData) => {
  try {
    const data = {
      lead: {
        company: postData.companyName,
        country_id: postData.selectedCountry,
        first_name: postData.firstName,
        last_name: postData.lastName,
        email: postData.email,
        role: postData.department,
        phone: postData.phoneNo,
        activity_id: postData.activity,
        message: postData.message,
        send_copy: postData.sendCopy,
        phone_code_id: postData.countryPhoneCode, // Include this in the data being sent
      },
    }

    const response = await fetch(`${process.env.API_URL}/leads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    const res = await response.json()
    return res
  } catch (error) {
    console.log(error)
  }
}

export const companyContactService = async (formData: FormData, id: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/companies/${id}/company_leads`,
      {
        method: 'POST',
        credentials: 'include',
        body: formData,
      }
    )
    const reponseData = await response.json()
    return reponseData
  } catch (error) {
    console.log(error)
  }
}

export const getCompanyContactUS = async (companyId: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/member/users?company_id=${companyId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }
    )
    const reponseData = await response.json()
    return reponseData
  } catch (error) {
    console.log(error)
  }
}

export const getContactUs = async (id: string | string[]) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/companies/${id}/contact`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}
